var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "display: flex;width: 880px;" },
    [
      _vm.pdfSrc
        ? _c(
            "div",
            { staticStyle: { width: "100%", height: "100%" } },
            [
              _c(
                "el-scrollbar",
                _vm._l(_vm.numPages, function(i) {
                  return _c("pdf", {
                    key: i,
                    attrs: { src: _vm.pdfSrc, page: i }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.excelSrc
        ? _c(
            "div",
            [
              _c(
                "el-scrollbar",
                [
                  _c("vue-office-excel", {
                    staticClass: "office-preview",
                    attrs: { src: _vm.excelSrc }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.wordSrc
        ? _c(
            "div",
            [
              _c(
                "el-scrollbar",
                [
                  _c("vue-office-docx", {
                    staticClass: "office-preview",
                    attrs: { src: _vm.wordSrc }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.photoList.length > 0
        ? _c(
            "viewer",
            { staticClass: "preview-img", attrs: { images: _vm.photoList } },
            _vm._l(_vm.photoList, function(item, index) {
              return _c("img", { key: index, attrs: { src: item } })
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }